import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ResearchDemandFilterOption extends BaseModel {
  static override constructorName = 'ResearchDemandFilterOption'

  id: string = ''
  name: string = ''
  color: string = ''
  value: boolean = false

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(ResearchDemandFilterOption)
